import React from "react";

const Features = () => {
	return (
		<section className="page__features features">
			<h2 className="features__title">
				Why you <span className="title--line">need</span> to participate
			</h2>

			<ul className="features__list">
				<li className="features__item">
					<img
						src="./img/features/star_01.svg"
						width="70"
						height="70"
						alt="star icon"
					/>
					<p className="features__text">
						Chance to take 1st place - in your city
					</p>
				</li>
				<li className="features__item">
					<img
						src="./img/features/winne_02.svg"
						width="70"
						height="70"
						alt="winne icon"
					/>
					<p className="features__text">
						Development of independence + free time for parents ;)
					</p>
				</li>
				<li className="features__item">
					<img
						src="./img/features/certification_03.svg"
						width="70"
						height="70"
						alt="certification icon"
					/>
					<p className="features__text">
						Personal diploma in different nominations for each participant
					</p>
				</li>
				<li className="features__item">
					<img
						src="./img/features/gift_04.svg"
						width="70"
						height="70"
						alt="gift icon"
					/>
					<p className="features__text">
						Prizes and discounts for subscribers and authorized users
					</p>
				</li>
				<li className="features__item">
					<img
						src="./img/features/email_05.svg"
						width="70"
						height="70"
						alt="email icon"
					/>
					<p className="features__text">
						Free diploma by email - 1 day after the competition
					</p>
				</li>
				<li className="features__item">
					<img
						src="./img/features/vk_06.svg"
						width="70"
						height="70"
						alt="vk icon"
					/>
					<p className="features__text">
						Publication of the works of the winners in Facebook .{" "}
						<a href="#" className="features__link">
							Subscribe!
						</a>
					</p>
				</li>
			</ul>
		</section>
	);
};

export default Features;
